import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { GroupService } from '../../../services/group.service';
import { ToastService } from '../../../services/toast.service';
import { CommonModule } from '@angular/common';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { BaseAlertComponent } from '../../alerts/base-alert/base-alert.component';

@Component({
  selector: 'app-group-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, BaseModalComponent, BaseAlertComponent],
  templateUrl: './group-create-modal.component.html',
  styleUrls: ['./group-create-modal.component.scss'],
})
export class GroupCreateModalComponent implements OnInit {
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();
  @Output() created = new EventEmitter<any>();

  groupForm: UntypedFormGroup;
  submitted = false;
  error: any = '';

  constructor(
    private fb: UntypedFormBuilder,
    private groupService: GroupService,
    private toastService: ToastService,
  ) {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required]],
      description: [''],
    });
  }

  ngOnInit(): void {}

  close() {
    this.open = false;
    this.submitted = false;
    this.error = '';
    this.groupForm.reset();
    this.openChange.emit(false);
  }

  submit() {
    this.submitted = true;
    this.error = '';
    if (!this.groupForm.valid) {
      return;
    }

    const payload = {
      name: this.groupForm.controls.name.value,
      description: this.groupForm.controls.description.value,
    };
    this.groupService.createGroup(payload).subscribe({
      next: (res) => {
        this.toastService.success(
          'Group Created!',
          `"${payload.name}" has been created successfully`,
        );
        this.created.emit(res);
        this.groupForm.reset();
        this.submitted = false;
        this.close();
      },
      error: (err) => {
        console.error('Could not create group', err);
        this.error =
          typeof err.error === 'object'
            ? err.error.error || JSON.stringify(err.error)
            : err.error || 'Error';
        this.error = JSON.parse(this.error);
        this.toastService.error(
          'Failed to Create Group',
          this.error?.detail || 'Could not create the group. Please try again.',
        );
      },
    });
  }
}
